import React, { useState, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { message, Spin } from "antd";
import { useNavigate } from "react-router-dom";

function Agreement() {
  const [formDatas, setFormDatas] = useState({
    brokerName: '',
    carrierName: '',
    carrierUSDOTMC: '',
    carrierPhone: '',
    agreementDate: '',
    printName: '',
    title: '',
    signature: '',
    signatureDate: '',
    paymentMethod: '',
    email: '',
    BankName:'',
    AccountNumber:'',
    RoutingNumber:'',
    RecieverMethod:''
  });
  const Navigation = useNavigate()
const [loading, setLoading]=useState(false)
  const agreementRef = useRef();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDatas({
      ...formDatas,
      [name]: value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // List of required fields
  const requiredFields = [
    "brokerName",
    "carrierName",
    "carrierUSDOTMC",
    "carrierPhone",
    "agreementDate",
    "printName",
    "title",
    "signature",
    "signatureDate",
    "paymentMethod",
    "email",
    "BankName",
    "AccountNumber",
    "RoutingNumber",
    "RecieverMethod"
  ];

  // Check for empty fields
  const emptyFields = requiredFields.filter(field => !formDatas[field]?.trim());

  if (emptyFields.length > 0) {
    alert(`Please fill in all required fields: ${emptyFields.join(", ")}`);
    return;
  }

  generatePDF(); // This will download the PDF
};



  const generatePDF = () => {
    const content = document.querySelector(".pdfcontent");
    const originalWidth = content.style.width; // Store the original width
    content.style.width = "1040px"; // Force desktop width before snapshot

    // Increase scale if you need higher resolution (but watch for large file sizes)
    html2canvas(content, { scale: 1 }).then((fullCanvas) => {
      // PDF setup
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Define margins (in mm)
      const margin = 10;
      const usableWidth = pdfWidth - margin * 2; // width inside left/right margins
      const usableHeight = pdfHeight - margin * 2; // height inside top/bottom margins

      // Ratio between canvas px and PDF mm
      // If the entire canvas width maps to `usableWidth` in mm,
      // then 1 mm = (canvas.width / usableWidth) px
      const pxPerMm = fullCanvas.width / usableWidth;

      // The number of vertical px that fit on one PDF page (inside the margins).
      // e.g. if usableHeight=277mm => 277 * pxPerMm px tall
      const pageHeightPx = usableHeight * pxPerMm;

      let pageY = 0; // Tracks how far down (in px) we’ve processed the large canvas
      while (pageY < fullCanvas.height) {
        // sliceCanvas will hold a “page” of content from the full canvas
        const sliceCanvas = document.createElement("canvas");
        const sliceCtx = sliceCanvas.getContext("2d");

        // The remaining height in the original canvas
        const remainingHeightPx = fullCanvas.height - pageY;
        // The slice to draw on this page
        const sliceHeightPx = Math.min(pageHeightPx, remainingHeightPx);

        // Match slice canvas dimensions to the portion we need
        sliceCanvas.width = fullCanvas.width;
        sliceCanvas.height = sliceHeightPx;

        // Copy just the region for this PDF page from fullCanvas
        sliceCtx.drawImage(
          fullCanvas,
          0,         // source X in fullCanvas
          pageY,     // source Y in fullCanvas
          fullCanvas.width,
          sliceHeightPx,
          0,         // destination X in sliceCanvas
          0,         // destination Y in sliceCanvas
          fullCanvas.width,
          sliceHeightPx
        );

        // Convert sliceCanvas to JPEG
        const pageData = sliceCanvas.toDataURL("image/jpeg", 1);

        // The displayed height in PDF units (mm) for this slice
        const sliceHeightMm = sliceHeightPx / pxPerMm;

        // Render the slice into the PDF
        pdf.addImage(
          pageData,
          "JPEG",
          margin, // left margin
          margin, // top margin
          usableWidth,
          sliceHeightMm
        );

        pageY += sliceHeightPx; // Move down to next page slice
        if (pageY < fullCanvas.height) {
          pdf.addPage();
        }
      }

     
      // Restore original width after PDF generation
      content.style.width = originalWidth;
      const pdfBlob = pdf.output("blob");
      // Send the PDF Blob to
      sendToEmail(pdfBlob);
    });

  };
  const sendToEmail = async (pdfBlob) => {
    setLoading(true);

    const formData = new FormData();
    formData.append("pdf", pdfBlob, "Agreement.pdf");
    formData.append("email", formDatas.email);
    formData.append("name", formDatas.brokerName);
    formData.append("carriername", formDatas.carrierName);
    formData.append("brokerName", formDatas.brokerName);

    try {
      const response = await fetch("https://servertrucking.vercel.app/api/send-pdf-email", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {

        const brokerResponse = await fetch("https://servertrucking.vercel.app/api/send-pdf-emailtobroker", {
          method: "POST",
          body: formData,
        });
        Navigation("/")
        if (brokerResponse.ok) {

          localStorage.clear();
        }
      } else {
        message.error("Failed to send email");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      message.error("Error sending email");
    } finally {
      setLoading(false);
    }
  };

 





  return (
 <>
 {
  loading ? (<Spin fullscreen={true}	/>):(null)
 }
 <>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Broker/Carrier Agreement</title>
  <link rel="stylesheet" href="css/styles.css" />
  <style
    dangerouslySetInnerHTML={{
      __html:
        '\n    body {\n    font-family: Arial, sans-serif;\n    background-color: #f9f9f9;\n    margin: 0;\n    padding: 0;\n}\n\n.container {\n    max-width: 1000px;\n    margin: 20px auto;\n    background: #fff;\n    padding: 20px;\n    border-radius: 10px;\n    \n}\n\n\n.header {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n        }\n\n        .header h1 {\n            margin: 0;\n            font-size: 24px;\n        }\n\n        .header p {\n            margin: 0;\n            font-size: 12px;\n            text-align: right;\n        }\nheader .logo {\n    max-width: 150px;\n    margin: 0 auto;\n}\n\nform {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\nlabel {\n    font-weight: bold;\n    color: #555;\n}\n\ninput,\nbutton {\n    padding: 10px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\ninput:focus {\n    border-color: #007bff;\n    outline: none;\n}\n\nbutton {\n    background: #007bff;\n    color: #fff;\n    cursor: pointer;\n    border: none;\n}\n\nbutton:hover {\n    background: #0056b3;\n}\n\n.agreement-text {\n    color: #666;\n    line-height: 1.5;\n    font-size: 14px;\n}\n\n.instructions {\n    background-color: #f9f9f9;\n    padding: 10px;\n    border-left: 4px solid #333;\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n\n.fields-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n    margin-top: 20px;\n}\n\n.field-group {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    width: 100%;\n}\n\n.input-group {\n    display: flex;\n    gap: 10px;\n}\n\ninput {\n    text-align: center;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    width: 100%;\n    box-sizing: border-box;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 20px 0;\n}\n\ntable td,\ntable th {\n    border: 1px solid #ccc;\n    padding: 10px;\n    text-align: left;\n}\n\n\n    /* Default styles for the checkbox group */\n    .checkbox-group {\n        display: flex;\n        flex-direction: column; /* Stack items vertically */\n        gap: 15px; /* Space between items */\n    }\n\n    /* Style the labels */\n    .checkbox-group label {\n        display: flex;\n        align-items: center;\n        font-size: 16px;\n        padding-left: 5px;\n        cursor: pointer;\n    }\n\n    /* Style the radio buttons */\n    .checkbox-group input[type="radio"] {\n        width: 20px;\n        height: 20px;\n        appearance: none; /* Remove default styling */\n        border: 2px solid #333; /* Dark border */\n        border-radius: 50%; /* Make it round */\n        background-color: white;\n        position: relative;\n        margin-right: 10px; /* Space between radio button and label */\n        transition: border-color 0.2s ease; /* Smooth transition */\n    }\n\n    /* Checked state for radio buttons */\n    .checkbox-group input[type="radio"]:checked {\n        background-color: #007bff; /* Blue background when checked */\n        border-color: #007bff;\n    }\n\n    /* Simple dot inside the radio button when checked */\n    .checkbox-group input[type="radio"]:checked::before {\n        content: \'\'; /* Empty content */\n        position: absolute;\n        top: 4px;\n        left: 4px;\n        width: 10px;\n        height: 10px;\n        background-color: white; /* White dot in the center */\n        border-radius: 50%; /* Make it round */\n    }\n\n    /* Hover effect for border */\n    .checkbox-group input[type="radio"]:hover {\n        border-color: #0056b3;\n    }\n\n    /* Responsive styles for mobile */\n    @media (max-width: 1024px) {\n        .checkbox-group {\n            align-items: flex-start; /* Align to the left */\n        }\n\n        .checkbox-group label {\n            font-size: 14px; /* Smaller font on mobile */\n        }\n\n        .checkbox-group input[type="radio"] {\n            width: 24px; /* Slightly bigger radio button on mobile */\n            height: 24px;\n        }\n    }\n\n.split-content {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n}\n\n.split-content .left {\n    flex: 2;\n}\n\n.split-content .right {\n    flex: 1;\n}\n\n.footer {\n    font-size: 12px;\n    text-align: center;\n    color: #666;\n    margin-top: 20px;\n}\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n    .container {\n        padding: 10px; /* Screen ke sides se thoda space dene ke liye */\n        margin: 10px; /* Extra spacing */\n        width: calc(100% - 20px); /* Total width adjust ki */\n        box-sizing: border-box; /* Ensure padding/margin border ke andar aaye */\n    }\n\n    header h1 {\n        font-size: 20px;\n    }\n\n    input,\n    button {\n        font-size: 14px;\n    }\n\n    table td,\n    table th {\n        font-size: 14px;\n    }\n\n    .fields-container {\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .split-content {\n        flex-direction: column;\n        padding: 10px; /* Extra space for split-content */\n    }\n\n    .split-content .left,\n    .split-content .right {\n        width: calc(100% - 20px); /* Left aur right ke beech space */\n        margin: 10px 0; /* Vertical margin */\n    }\n}\n\n    \n.payment-option {\n            display: inline-block;\n            margin-right: 20px; /* Space between options */\n        }\n\n        /* Ensure the label and radio button are aligned on the same line */\n        label {\n            margin-left: 5px; /* Adjust spacing between radio button and label */\n        }\n        /* Mobile View */\n\n    '
    }}
  />
  <div className="container pdfcontent" ref={agreementRef}>
    <header>
      <img
        src="images/logo.png"
        alt="Company Logo"
        className="logo"
        style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}
      />
    </header>
    <form onSubmit={handleSubmit}>

    <section className="agreement-form">
      <h1>Broker/Carrier Agreement </h1>
        <p className="agreement-text">
          This Broker/Carrier Agreement is being entered into by and between:
        </p>
        <label htmlFor="broker-name">Broker Name:</label>
        <input
              type="text"
              id="broker-name"
              name="brokerName"
              placeholder="Enter Broker Name"
              value={formDatas.brokerName}
              onChange={handleInputChange}
              required
            />
        <p className="agreement-text">
          Safe and Reliable Transportation hereinafter referred to as
          “BROKER”), and:
        </p>
        <label htmlFor="carrier-name">Carrier Name:</label>
        <input
              type="text"
              id="carrier-name"
              name="carrierName"
              placeholder="Enter Carrier Name"
              value={formDatas.carrierName}
              onChange={handleInputChange}
              required
            />
        <label htmlFor="carrier-name">Carrier USDOT/MC: :</label>
        <input
              type="text"
              id="carrier-usdot/mc"
              name="carrierUSDOTMC"
              placeholder="Enter Carrier USDOT/MC"
              value={formDatas.carrierUSDOTMC}
              onChange={handleInputChange}
              required
            />
        <label htmlFor="carrier-name">Carrier Phone&nbsp;number:</label>
        <input
              type="text"
              id="carrier-phone"
              name="carrierPhone"
              placeholder="Enter Phone Number"
              value={formDatas.carrierPhone}
              onChange={handleInputChange}
              required
            />
        <p className="agreement-text">
          (hereinafter referred to as “CARRIER”) as defined below, on this:
        </p>
        <label htmlFor="agreement-date">Agreement Date:</label>
        <input
              type="date"
              id="agreement-date"
              name="agreementDate"
              value={formDatas.agreementDate}
              onChange={handleInputChange}
              required
            />
        <p className="agreement-text">
          This Agreement between  Safe and Reliable Transportation and the
          Carrier/Broker is intended to enhance the joint efforts of both
          entities in developing a more secure environment by improving the
          security for the transportation of conveyances and cargo throughout
          the commercial process. The Carrier/Broker agrees to develop,
          implement and stay current, within a framework consistent with the
          listed recommendations, a verifiable, documented program to enhance
          security procedures throughout its supply chain process. Where the
          Carrier/Broker does not exercise control of the production facility,
          distribution entity, or process in the supply
          recommendations/guidelines to those entities.
        </p>
        <br />
       
        <p>
          Specifically, Carriers/Brokers will attempt to meet at a minimum, the
          following Criteria:
        </p>
        <br />
        <br />
        <p>
          Broker Obligations: Broker shall pay CARRIER for services rendered in
          an amount equal to the rates and charges agreed to as set forth on any
          Load Confirmation(s) that is issued and that supplements and amends
          this Agreement to the extent its terms conflict with those in this
          Agreement. This Agreement or the Load Confirmation also governs all
          assessorial services which may be required or performed. CARRIER shall
          not bill for any accessorial or other charge not approved in this
          Agreement or in any Load Confirmation(s). Rates may be amended orally
          but must be confirmed in writing within five working days of the
          modification in order to remain binding between the PARTIES. As a
          condition precedent to payment
        </p>
        <p>
          CARRIER must submit proof of delivery with its invoices, and the
          invoices must reflect that CARRIER delivered the freight to its final
          destination. a. BROKER agrees to arrange for the transportation of a
          shipper’s freight with CARRIER pursuant to the terms of this
          Agreement, and to comply with all federal, state, and local laws and
          regulations pertaining to the brokerage services covered by this
          Agreement
        </p>
        <p>
          The Parties agree that BROKER’S responsibilities under this Agreement
          are limited to arranging for the transportation of a shipper’s freight
          with CARRIER, and not actually performing the transportation services,
          possessing the freight, or controlling the means or methods of the
          transportation.
        </p>
        <p>
        <p>
        As a condition precedent to payment, all payments must be completed as per agreed terms. In certain cases, failure to process dispatch fees on time may result in delays or limitations in accessing essential shipping documents such as BOL and tracking links.
        </p>
        </p>
        <h3>
          <b>SLOT FEE (REFUNDABLE)</b>
        </h3>
        <p>
          The Carrier shall make a security deposit of $195 by direct payment,
          through instant payment methods to the  Safe and Reliable Transportation. It is a refundable fee upon the first delivery,
          along with the payment of the load, for the securement of the load.
          Once carrier pays $195 to Safe and Reliable Transportation
          carrier must get a Receipt for the Deposit Fee by the representative.
          The security deposit shall be refundable upon the termination of this
          Agreement, subject to any outstanding obligations or damages incurred
          by the Carrier. The Carrier may terminate this Agreement with one
          week's written notice to the Company. Broker is responsible for
          Detention.
        </p>
        <h3>
          <b>Payment Terms:</b>
        </h3>
        <p>
          Signed Copy of Rate confirmation and the company’s Invoice to the
          broker to get paid. We have two options. We charge 2% for Quick-pay (
          same-day deposit). No fees for 24 hours deposit. Factoring
        </p>
        <h3>
          <b>Carrier Obligations:</b>
        </h3>
        <p>
          To be eligible for Accessorials/Incidentals, Carrier must: Be checked
          in to shipper OR receiver by the appointment time. Submit all proof of
          detention, accessorial, incidentals within 24-48 hours of delivery.
          Detention accrual begins 2 hours after appointment time at
          shipper/receiver IF: Carrier must notify Broker after 60 minutes of
          waiting. Provide time stamped BOL within 48 hours of delivery.
          Detention Rate-$40/hr after 2 hours. Max $200 detention per stop.
          Layover, Truck Order Not Used (TONU): Carrier must contact Broker to
          request Delays or cancellations must be confirmed by Broker Layovers:
          $200 Dry Van or $250 Running Reefers. TONU: $200.
        </p>
        <h3>
          <b>Term:</b>
        </h3>
        <p>
          The term of this Agreement shall be 60 day’s, commencing on the date
          listed above. If not cancelled by one of The Parties, the Agreement
          shall automatically renew itself for consecutive one year terms. The
          Agreement can be terminated at any time by either of The Parties with
          thirty (30) days written or electronic notice to the other party
          provided all balances are settled. This Agreement cannot, by law,
          exempt the Carrier/Broker from any regulatory sanctions in the event
          that discrepancies are discovered during a physical examination of
          cargo or the review of documents associated with the carrier's Customs
          transactions.{" "}
        </p>
        <p>
          Nothing in the Agreement relieves Carrier/Broker of any
          responsibilities with respect to Canadian and United States law,
          including Customs Regulations.{" "}
        </p>
        <p>Print Name:</p>
        <input
              type="text"
              id="print-name"
              name="printName"
              placeholder="Enter Print Name"
              value={formDatas.printName}
              onChange={handleInputChange}
              required
            />
        <p>Title:</p>
        <input type="text"               value={formDatas.title}
                      onChange={handleInputChange}

 id="title" name="title" placeholder="Enter Title" />
        <p>Signature:</p>
       
              <input
              type="text"
              id="signature"
              name="signature"
              placeholder="Enter Signature"
              value={formDatas.signature}
              onChange={handleInputChange}
              required
            />
        <p>Date:</p>
        <input
              type="date"
              id="signature-date"
              name="signatureDate"
              value={formDatas.signatureDate}
              onChange={handleInputChange}
              required
            />        <p>
          9528 Baltimore, Ave
Laurel, MD 20723 PH# (301) 709-7924 FAX# (301) 709-7924
        </p>
        <p>
          <strong>
            President: <u>James Martin</u>
          </strong>
        </p>
        <p>
          <strong>
            Safe and Reliable Transportation ( INCORPORATED SINCE 2020)
          </strong>
        </p>
        <p>
          <strong>INFORMATION</strong>
        </p>
        <p>MC# 636861 USDOT# 2241595</p>
        <h3>Select Payment Option:</h3>
        <div className="checkbox-group">
          <label>
            <input
              type="radio"
              name="payment_method"
              defaultValue="CASHAPP TRANSFER"
              onChange={(e) => setFormDatas({ ...formDatas, paymentMethod: e.target.value })}

            />{" "}
            CASHAPP TRANSFER
          </label>
          <label>
            <input
              type="radio"
              name="payment_method"
              defaultValue="ZELLE TRANSFER"
              onChange={(e) => setFormDatas({ ...formDatas, paymentMethod: e.target.value })}
            />{" "}
            ZELLE TRANSFER
          </label>
          <label>
            <input
              type="radio"
              name="payment_method"
              defaultValue="VENMO TRANSFER"
              onChange={(e) => setFormDatas({ ...formDatas, paymentMethod: e.target.value })}

            />{" "}
            VENMO TRANSFER
          </label>
          {/*<label><input type="radio" name="payment_method" value="WIRE TRANSFER"> WIRE TRANSFER</label>*/}
        </div>
        <h3>How you get paid.
        </h3>
        <div className="checkbox-group">
          <label>
            <input
              type="radio"
              name="RecieverMethod"
              defaultValue="COD"
              onChange={(e) => setFormDatas({ ...formDatas, RecieverMethod: e.target.value })}
              />{" "}
            COD
          </label>
          <label>
            <input
              type="radio"
              name="RecieverMethod"
              defaultValue="ACH DIRECT DEPOSIT METHOD"
              onChange={(e) => setFormDatas({ ...formDatas, RecieverMethod: e.target.value })}

            />{" "}
             ACH DIRECT DEPOSIT METHOD

          </label>
          <p>Bank Name:</p>
        <input
              type="text"
              id="print-name"
              name="BankName"
              placeholder="Enter Bank Name"
              value={formDatas.BankName}
              onChange={handleInputChange}
              required
            />
                 <p>Account Number:</p>
        <input
              type="text"
              id="print-name"
              name="AccountNumber"
              placeholder="Enter Account Number"
              value={formDatas.AccountNumber}
              onChange={handleInputChange}
              required
            />
                 <p>Routing Name:</p>
        <input
              type="text"
              id="print-name"
              name="RoutingNumber"
              placeholder="Enter Routing Name"
              value={formDatas.RoutingNumber}
              onChange={handleInputChange}
              required
            />
          {/*<label><input type="radio" name="payment_method" value="WIRE TRANSFER"> WIRE TRANSFER</label>*/}
        </div>
        <p>
          <strong>ENTIRE CONTRACT:</strong>
        </p>
        <p>
          The provisions contained in this AGREEMENT properly express and
          memorialize the complete understanding and agreement between the
          parties, including those contained in all prior agreements, both
          verbal or written, and there are no other agreements or understandings
          between the parties, express or implied, except as set forth herein.
        </p>
        <p>
          <strong>NOTICES:</strong>
        </p>
        <p>
          If carrier wants to end the contract or want to switch the jobs,
          carrier must give prior notice of 3 days before ending the contract.
        </p>
        <div
          style={{
            pageBreakBefore: "always",
            fontFamily: "Arial, sans-serif",
            margin: 0,
            padding: 20
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              padding: 10,
              boxSizing: "border-box"
            }}
          >
            {/* Logo and Text on the top-left */}
            <div
              style={{ position: "absolute", top: 0, left: 0, fontSize: 14 }}
            >
              <img
                src="images/fsmcsa.png"
                alt="Company Logo"
                style={{ width: 50, height: 50, marginBottom: 5 }}
              />
              <p>
                <strong>U.S. Department of Transportation</strong>
                <br />
                Federal Motor Carrier Safety Administration
              </p>
            </div>
            {/* Address and Service Date on the top-right */}
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                textAlign: "right",
                fontSize: 14
              }}
            >
              <p>1200 New Jersey Ave., S.E.</p>
              <p>Washington, DC 20590</p>
              <p>
                <strong>SERVICE DATE</strong>
              </p>
              <p>May 21, 2022</p>
            </div>
            {/* Main Content (Certificate Info) */}
            <div style={{ textAlign: "center", marginTop: 100, fontSize: 16 }}>
              <p>
                <strong>CERTIFICATE</strong>
                <br />
                MC-636861
              </p>
              <p>U.S. DOT No. 2241595</p>
              <p> Safe and Reliable Transportation</p>
              <p>9528 Baltimore, Ave
Laurel, MD 20723</p>
              <p>ORLANDO, FL 32825</p>
            </div>
          </div>
          {/* Mobile Responsive Styles */}
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n    @media only screen and (max-width: 600px) {\n        .logo {\n            width: 40px;\n            height: 40px;\n        }\n\n        /* Adjust text size for smaller screens */\n        p {\n            font-size: 12px;\n        }\n\n        /* Adjust positions for smaller screens */\n        .left-section, .right-section {\n            position: relative;\n            top: auto;\n            left: auto;\n            right: auto;\n            width: 100%;\n            text-align: center;\n        }\n\n        .right-section {\n            margin-top: 20px;\n        }\n\n        /* Center the main content and ensure there is no overflow */\n        .main-content {\n            margin-top: 80px;\n        }\n    }\n"
            }}
          />
          <p>
            This License is evidence of the applicant's authority to engage in
            operations, in interstate or foreign as a broker, arranging for
            transportation of freight (except household goods) by Motor Vehicle.
          </p>
          <p>
            This authority will be effective as long as the broker maintains
            insurance coverage for the protection of the public (49 CFR 387) and
            the designation of agents upon whom process may be served (49 CFR
            366). The applicant shall also render reasonably continuous and
            adequate service to the public. Failure to maintain compliance will
            constitute sufficient grounds for revocation of this authority.
          </p>
          <img
            src="images/jef.png"
            alt="Company Logo"
            style={{ width: "auto", height: "auto" }}
          />
          <p>Jeffrey L. Secrist, Chief</p>
          <p>Information Technology Operations Division</p>
          <p>
            <strong>NOTE:</strong>
          </p>
          <p>
            Willful and persistent noncompliance with applicable safety fitness
            regulations as evidenced by a DOT safety fitness rating of
            Unsatisfactory or by other indicators, could result in a proceeding
            requiring the holder of this certificate or permit to show cause why
            this authority should not be suspended or revoked.
          </p>
          <label htmlFor="user-email">Your Email:</label>
          <input
              type="email"
              id="user-email"
              name="email"
              placeholder="Enter Your Email"
              value={formDatas.email}
              onChange={handleInputChange}
              required
            />
          <center>
            <br />
                  </center>

        </div>

    </section>
    </form>
  
  </div>
  <div className="d-flex justify-content-center">
  <button className="default-btn" onClick={(e)=>{handleSubmit(e)}}>
      Submit Agreement
    </button> 
  </div>

</>

 </>
  )
}

export default Agreement
